import { StimHomeCheckInDiscomfort, StimHomeCheckInIncompleteReason } from '../api/hooks/mobile.stimHome';

/**
 * 치료 체크인 선택 항목의 화면 라벨 ↔ 서버 코드.
 * 환자 앱(작성·수정·기록 상세)과 환자 대시보드가 같은 표를 쓴다 — 같은 기록을 다르게 부르면 안 된다.
 * 라벨은 TreatmentCheckinScreen 의 선택 항목 문구와 같아야 한다(코드로 되돌릴 때 매칭 기준이다).
 */
export const DISCOMFORT_BY_LABEL: Record<string, string> = {
  따끔함: StimHomeCheckInDiscomfort.Stinging,
  가려움: StimHomeCheckInDiscomfort.Itching,
  두통: StimHomeCheckInDiscomfort.Headache,
  '피부 발적': StimHomeCheckInDiscomfort.SkinRedness,
  '타는 느낌': StimHomeCheckInDiscomfort.Burning,
  기타: StimHomeCheckInDiscomfort.Etc,
  없음: StimHomeCheckInDiscomfort.None,
};

export const STOP_REASON_BY_LABEL: Record<string, string> = {
  '컨디션 문제': StimHomeCheckInIncompleteReason.PoorCondition,
  '기기, 소모품 문제': StimHomeCheckInIncompleteReason.DeviceOrConsumableIssue,
  '불편감이 심함': StimHomeCheckInIncompleteReason.SevereDiscomfort,
  '시간 부족': StimHomeCheckInIncompleteReason.LackOfTime,
  기타: StimHomeCheckInIncompleteReason.Etc,
};

const labelByCode = (byLabel: Record<string, string>) =>
  Object.fromEntries(Object.entries(byLabel).map(([label, code]) => [code, label]));

export const DISCOMFORT_LABEL = labelByCode(DISCOMFORT_BY_LABEL);
export const STOP_REASON_LABEL = labelByCode(STOP_REASON_BY_LABEL);

/** 서버 코드 목록 → 화면 라벨. Set 으로 선언돼 있지만 JSON 으로는 배열로 오므로 둘 다 받는다. */
export const toOptionLabels = (codes: unknown, map: Record<string, string>): string[] =>
  Array.from((codes as Iterable<string>) ?? []).map((code) => map[code] ?? code);

/** 화면 라벨 목록 → 서버 코드. 표에 없는 라벨은 버린다. */
export const toOptionCodes = (labels: string[], map: Record<string, string>) =>
  labels.map((label) => map[label]).filter((code): code is string => !!code);
